import { OrderPayablesToolPanel } from "../OrderPayablesToolPanel";
import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesProcess extends Layout {
    buttonManageRecurring: Button;
    buttonProcess: Button;
    layoutOrderPayablesToolPanel: OrderPayablesToolPanel;
    panelTaskFilters: Panel;
    panelTpTaskFilters: Panel;
    sourceOrderPayablesCache: DataSource;
    tableOrderPayables: Table;
}
